import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import * as zIndexes from "zIndexes.module.scss";

const useStyles = makeStyles(() => ({
  screenShare: {
    background: "url(../../assets/screenshare_on.svg) no-repeat transparent",
    position: "absolute",
    width: "20px",
    height: "20px",
    overflow: "hidden",
    bottom: "0",
    zIndex: zIndexes.mapAvatarContainerZIndex + 1,
    left: "0px",
    top: "0px",
    backgroundSize: "30px",
    backgroundPositionX: "-5px",
  },
  avChat: {
    position: "absolute",
    width: "20px",
    height: "20px",
    bottom: 0,
    zIndex: zIndexes.mapAvatarContainerZIndex + 1,
    right: 0,
    padding: "1px",
    background: "#7eda80",
    color: "#fff",
    borderRadius: "100%",
    boxShadow: "2px 2px 4px 0px rgba(0, 0, 0, 0.5)",
    display: "none",
    border: "none",
    "& svg": {
      width: "100%",
      height: "100%",
      verticalAlign: "text-top",
    },
    "&:hover": {
      display: "inline-block",
      cursor: "pointer",
    },
  },
  hasIssues: {
    bottom: "25px",
    right: "-10px",
  },
  speaker: {
    position: "absolute",
    top: "-4px",
    right: "-5px",
    width: "27px",
    height: "27px",
    zIndex: zIndexes.mapAvatarContainerZIndex,
  },
}));

export default useStyles;
